import { createContext } from "react";

/**
 * Color scheme for the bottom nav. "light" is the default frosted bar; "dark"
 * is the iOS black feed / locked-feed variant. NavBar provides this; NavButton
 * (and its icon tints) consume it. Lives in its own module so both NavBar and
 * NavButton can import it without a circular dependency, and so the component
 * files stay fast-refresh friendly (no non-component exports).
 */
export type NavVariant = "light" | "dark";

export const NavVariantContext = createContext<NavVariant>("light");
